/* Mqamis (21/10) : bloc « Complétez avec des échantillons » des fiches parfum.
   1 échantillon -5 %, 2 -10 %, 3 et plus -15 % (codes MQTENUE5 / 10 / 15 posés au panier, les autres codes déjà présents sont conservés).
   Le coffret 3 x 5 ml compte pour 3 échantillons. Aperçu du coffret en rupture : &demo_echantillons=1 dans l'adresse. */
(function () {
  var d = document;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function init(pk) {
    var tiers = [5, 10, 15];
    var codes = String(pk.getAttribute('data-codes') || '').split(',').filter(function (x) { return x; });
    function tierIdx(n) { return n <= 0 ? -1 : Math.min(n, tiers.length) - 1; }
    var form = d.querySelector('form[action*=cart][id^=product-form-]') || d.querySelector('product-form form');
    function mainId() { var i = form && form.querySelector('[name=id]'); return i ? i.value : null; }
    var vars = {};
    try { vars = JSON.parse(pk.querySelector('[data-mq-vars]').textContent); } catch (e) {}
    function mainPrice() { var v = vars[mainId()]; return v ? v.p : (parseInt(pk.getAttribute('data-main-price'), 10) || 0); }
    var was = pk.querySelector('[data-mq-was]'), now = pk.querySelector('[data-mq-now]'), save = pk.querySelector('[data-mq-save]');
    var btn = pk.querySelector('[data-mq-add]'), msg = pk.querySelector('[data-mq-msg]'), hint = pk.querySelector('[data-mq-hint]');
    var tierEls = pk.querySelectorAll('.mq-pack__tier'), sum = pk.querySelector('.mq-pack__sum');
    var cof = pk.querySelector('[data-mq-cof]');
    var curN = 0;
    function rows() { return pk.querySelectorAll('.mq-pack__it:not(.is-main)'); }
    function update() {
      var mp = mainPrice();
      var mpEl = pk.querySelector('[data-mq-main-price]');
      if (mpEl) mpEl.textContent = money(mp);
      var total = mp, n = 0;
      rows().forEach(function (it) {
        var cb = it.querySelector('.mq-pack__cb'), v = it.querySelector('.mq-pack__v');
        it.classList.toggle('is-off', !cb.checked);
        if (cb.checked) { total += parseInt(v.getAttribute('data-price'), 10) || 0; n += parseInt(it.getAttribute('data-n') || '1', 10); }
      });
      if (cof) { var cc = pk.querySelector('[data-coffret] .mq-pack__cb'); cof.hidden = !(cc && cc.checked); }
      curN = n;
      var ti = tierIdx(n), pct = ti >= 0 ? tiers[ti] : 0;
      for (var k = 0; k < tierEls.length; k++) { tierEls[k].classList.toggle('is-on', k === ti); tierEls[k].classList.toggle('is-done', k < ti); }
      if (n <= 0) {
        hint.textContent = 'Cochez un échantillon pour obtenir -' + tiers[0] + ' % sur l’ensemble.';
        if (sum) sum.hidden = true;
        btn.hidden = true;
      } else {
        var nx = ti + 1;
        hint.textContent = nx < tiers.length
          ? 'Remise de -' + pct + ' % appliquée. Ajoutez 1 échantillon de plus pour passer à -' + tiers[nx] + ' %.'
          : 'Remise maximale de -' + pct + ' % appliquée sur l’ensemble.';
        var fin = Math.round(total * (1 - pct / 100));
        was.textContent = money(total);
        now.textContent = money(fin);
        save.textContent = 'Vous économisez ' + money(total - fin) + ' (-' + pct + ' %)';
        save.hidden = false;
        if (sum) sum.hidden = false;
        btn.hidden = false;
        btn.textContent = 'Ajouter avec les échantillons · ' + money(fin);
      }
    }
    if (/[?&]demo_echantillons=1/.test(location.search)) pk.querySelectorAll('[data-demo]').forEach(function (e) { e.hidden = false; });
    update();
    pk.addEventListener('change', update);
    d.addEventListener('change', function (e) {
      if (!pk.contains(e.target) && e.target.closest('variant-selects,variant-radios,.product-form__input,form[id^=product-form-]')) setTimeout(update, 120);
    });
    function applyCode(code) {
      var cartUrl = root() + 'cart';
      if (!code) { window.location.href = cartUrl; return; }
      fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        var keep = (c.discount_codes || []).map(function (x) { return x.code; }).filter(function (x) { return x && !/^MQTENUE/i.test(x); });
        keep.push(code);
        return fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) }).then(function (r) { if (!r.ok) throw new Error('discount'); return r.json(); });
      }).then(function () { window.location.href = cartUrl; }).catch(function () {
        window.location.href = root() + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
      });
    }
    btn.addEventListener('click', function () {
      var id = mainId();
      if (!id) return;
      var items = [{ id: parseInt(id, 10), quantity: 1 }];
      var err = '';
      rows().forEach(function (it) {
        var cb = it.querySelector('.mq-pack__cb');
        if (!cb.checked) return;
        var v = it.querySelector('.mq-pack__v');
        var line = { id: parseInt(v.value, 10), quantity: 1 };
        if (it.hasAttribute('data-coffret')) {
          var picks = [];
          if (cof) cof.querySelectorAll('select').forEach(function (s) { if (s.value) picks.push(s.value); });
          if (picks.length < 3) { err = 'Choisissez les 3 parfums de votre coffret.'; return; }
          line.properties = { 'Parfums du coffret': picks.join(', ') };
        }
        items.push(line);
      });
      if (err) { if (msg) msg.textContent = err; return; }
      var ti = tierIdx(curN), code = (ti >= 0 && codes[ti]) ? codes[ti] : '';
      btn.setAttribute('aria-busy', 'true');
      if (msg) msg.textContent = '';
      fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { applyCode(code); })
        .catch(function (e2) {
          btn.removeAttribute('aria-busy');
          if (msg) msg.textContent = (e2 && e2.description) || 'Un article n’est plus disponible.';
        });
    });
  }
  function ready(f) { if (d.readyState !== 'loading') f(); else d.addEventListener('DOMContentLoaded', f); }
  ready(function () { d.querySelectorAll('[data-mq-samples]').forEach(init); });
})();